import { RotateUpdater } from "./RotateUpdater";
export async function loadAngleUpdater(engine) {
    await engine.addParticleUpdater("rotate", (container) => new RotateUpdater(container));
}
